import { buildDhlPickupPointMapUrl, normalizePointType } from '../dhlPickupPointMap.js'
import { checkoutContextFingerprint, createCheckoutContext, pickupPointTypeForShipping } from './context.js'
import { normalizePickupPoint, pickupPointIdentifier, withPickupPointCountry } from './pickupPoint.js'

export function buildCheckoutMapUrl(settings, context) {
  const checkoutContext = createCheckoutContext(context)
  const mapUrl = String(settings?.pickupPointMapUrl ?? settings?.mapUrl ?? '').trim()
  if (mapUrl === '' || !checkoutContext.countryIso || !checkoutContext.paymentType) {
    return null
  }

  const url = buildDhlPickupPointMapUrl(mapUrl, checkoutContext.countryIso, '')
  if (checkoutContext.paymentType === 'cod') {
    url.searchParams.set('options_pickup_cod', 'T')
  }
  if (checkoutContext.countryIso === 'DE') {
    const pointType = pickupPointTypeForShipping(settings, checkoutContext.shippingId)
    if (pointType === 'packStation') {
      url.searchParams.set('ptype', 'packStation')
    } else if (pointType === 'parcelShop') {
      url.searchParams.set('ptype', 'parcelShop')
    }
  }

  return url
}

export function parsePickupPointMessagePayload(data) {
  let payload = data
  for (let level = 0; level < 4; level += 1) {
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload)
      } catch {
        return null
      }
    }
    if (!payload || typeof payload !== 'object') {
      break
    }

    const nestedPayload = payload.point ?? payload.pickupPoint ?? payload.payload
    if (nestedPayload === undefined) {
      break
    }
    payload = nestedPayload
  }

  return normalizePickupPoint(payload)
}

export function createMapSession({ iframe, origin, context, source, pointType } = {}) {
  let normalizedOrigin = ''
  try {
    normalizedOrigin = new URL(origin).origin
  } catch {
    normalizedOrigin = ''
  }

  return {
    active: normalizedOrigin !== '',
    origin: normalizedOrigin,
    source: source ?? iframe?.contentWindow ?? null,
    contextFingerprint: checkoutContextFingerprint(context),
    pointType: normalizePointType(pointType),
  }
}

export function closeMapSession(session) {
  if (session) {
    session.active = false
  }
}

export function acceptPickupPointMessage(event, session, currentContext) {
  if (!session?.active || event?.origin !== session.origin || event?.source !== session.source) {
    return null
  }
  if (checkoutContextFingerprint(currentContext) !== session.contextFingerprint) {
    return null
  }

  const context = createCheckoutContext(currentContext)
  const point = parsePickupPointMessagePayload(event.data)
  if (!point || pickupPointIdentifier(point) === '') {
    return null
  }

  if (context.countryIso === 'DE') {
    const pointType = normalizePointType(point.type)
    const sessionPointType = normalizePointType(session.pointType)
    if (!['packStation', 'parcelShop'].includes(pointType)) {
      if (!['packStation', 'parcelShop'].includes(sessionPointType)) {
        return null
      }
      point.type = sessionPointType
    } else if (sessionPointType && pointType !== sessionPointType) {
      return null
    }
  }

  return withPickupPointCountry(point, context.countryIso)
}
